export const TAKE_ITEMS = 50;
